var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.hero__slider .slider');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        arrows: false,
        dots: true,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    });
}


// Slider - Categories
//-----------------------------------------------------------------
mp.sliderCategories = function() {
    var $slider = $('.products__categories_slider .slider');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: false,
        variableWidth: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        initialSlide: 6,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $active_slide = $slider.find('.slick-active .active').parent().data("slick-index");

    $('.products__categories_slider .slider').slick('slickGoTo', $active_slide);
}


// Slider - Products
//-----------------------------------------------------------------
mp.sliderProducts = function() {
    var $slider = $('.products__slider .slider');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}





$(document).ready(function (){
    mp.sliderHero();
    mp.sliderCategories();
    
    //mp.sliderProducts();
    //mp.sliderProductsGallery();
});